import { useTranslation } from "react-i18next"
import { graphql, PreloadedQuery, useFragment, usePreloadedQuery } from "react-relay"
import { Banner } from "@/components/ui/banner"
import { hasMoreDataWarning_waitingRoomAppointments$key } from "@/modules/waiting-room/components/appointment-table/__generated__/hasMoreDataWarning_waitingRoomAppointments.graphql"
import { WaitingRoomAppointmentsQuery } from "@/modules/waiting-room/services/__generated__/WaitingRoomAppointmentsQuery.graphql"
import { waitingRoomQuery } from "@/modules/waiting-room/services/WaitingRoomAppointmentsQuery"

const HasMoreDataWarningFragment = graphql`
  fragment hasMoreDataWarning_waitingRoomAppointments on WaitingRoomAppointmentsOutput {
    hasMoreData
  }
`

interface HasMoreDataWarningProps {
  queryReference: PreloadedQuery<WaitingRoomAppointmentsQuery>
}

const HasMoreDataWarning = ({ queryReference }: HasMoreDataWarningProps) => {
  const { t } = useTranslation()

  const { waitingRoomAppointments } = usePreloadedQuery<WaitingRoomAppointmentsQuery>(waitingRoomQuery, queryReference)

  const { hasMoreData } = useFragment<hasMoreDataWarning_waitingRoomAppointments$key>(
    HasMoreDataWarningFragment,
    waitingRoomAppointments,
  )

  return (
    hasMoreData && (
      <div className="px-8">
        <Banner type="inline" variant="warning" data-testid="too-many-appointments-banner">
          {t("scheduling.waitingRoom.tooManyAppointments.message")}
        </Banner>
      </div>
    )
  )
}
export { HasMoreDataWarning }
